import Pusher from 'pusher-js';
import Echo from 'laravel-echo';

class PusherService {
  constructor(context) {
    this.context = context;
  }
  instance;
  private(channel) {
    return this.getInstance().private(channel);
  }
  leave(channel) {
    return this.getInstance().leave(channel);
  }
  getInstance() {
    if (!this.instance) {
      this.init();
    }
    return this.instance;
  }
  init() {
    const ctx = this.context;

    this.instance = new Echo({
      broadcaster: 'pusher',
      client: new Pusher(
        ctx.$config.pusherAppKey, {
        cluster: ctx.$config.pusherAppCluster,
        forceTLS: true,
        authEndpoint: `${ctx.$config.ocusApiUrl}/broadcasting/auth`,
        auth: {
          headers: {
            get Authorization() {
              return ctx.$auth.strategy.token.get()
            },
            Accept: 'application/json',
          },
        },
      }),
      namespace: false,
    });
  }
}

// Inject plugin in instance
export default (context, inject) => {
  inject('PusherService', new PusherService(context));
}
